import ChatClient from "./index";
import dayjs from "./components/dayjs";
// Pages where the chatbot must NOT mount (e.g. live-chat landing pages).
var EXCLUDED_PAGES = [
    "/live-chat",
    "/partner-live-chat",
    "/broadband-upgrade",
    "/live-chat-hosting",
];
var GA_MEASUREMENT_ID = "G-02EEHPCQNH";
var initSitefinityChatClient = function () {
    var element = document.getElementById("chatbot");
    if (!element)
        return;
    var isExcludedPage = EXCLUDED_PAGES.some(function (path) {
        return window.location.pathname.includes(path);
    });
    if (isExcludedPage)
        return;
    console.log("Initializing Zeni Chatbot");
    var hour = dayjs().tz("Europe/London").hour();
    var timeOfDay = "Morning";
    if (hour >= 12 && hour < 18) {
        timeOfDay = "Afternoon";
    }
    else if (hour >= 18) {
        timeOfDay = "Evening";
    }
    var uiLabels = {
        title: "Chat with Zeni",
        introMessage: "Good ".concat(timeOfDay, " {name}, I'm Zeni, your digital assistant. \n\n I can offer solutions to technical difficulties and help guide you around the site. \n\n How can I help you today?"),
        buttonLabel: "Start Chat",
        sendButtonLabel: "Send",
        textAreaPlaceholder: "Type your message here...",
        preChatFormTitle: "Start a conversation",
        preChatButtonLabel: "Start Chat",
        continueChatButtonLabel: "Stay with Zeni",
        humanHandoffButtonLabel: "Click to start transfer",
        errorHandoffButtonLabel: "Speak with a person",
        errorTryAgainButtonLabel: "Try again",
    };
    // Google Analytics — previously initialised by the CMS inline script.
    var w = window;
    w.dataLayer = w.dataLayer || [];
    function gtag() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        w.dataLayer.push(args);
    }
    gtag("js", new Date());
    gtag("config", GA_MEASUREMENT_ID);
    ChatClient({
        botName: "Zeni",
        element: element,
        width: "360px",
        height: "500px",
        chatbotEndpoint: SITEFINITY_CHATBOT_ENDPOINT,
        uiLabels: uiLabels,
        assistantId: ASSISTANT_ID,
        gtag: gtag,
        // NB: current contract — server owns team availability, so no client-side
        // in-hours/OOH split and no `departments`. Cast bypasses the (aspirational)
        // required `departments` field the live prod config also omits.
    });
};
initSitefinityChatClient();
// Keep the window.ChatClient global exposed (shared scriptConfig library
// export). Harmless alongside self-init; preserves back-compat.
export default ChatClient;
